import { useUrlState } from "@/lib/useUrlState";
import AuditLogPage from "@/components/AuditLogPage";
import CostCodesPage from "@/estimating/CostCodesPage";
import UsersRolesPage from "@/components/UsersRolesPage";
import DirectoryPage from "@/estimating/DirectoryPage";
import FieldCodesPage from "@/components/FieldCodesPage";
import FieldSettingsPage from "@/fieldops/pages/SettingsPage";
import SubTabs from "@/components/SubTabs";
import { RoleProvider } from "@/fieldops/context/RoleContext";
import { NavHistoryProvider } from "@/fieldops/context/NavHistoryContext";
import EmailTemplatesPage from "@/components/EmailTemplatesPage";
import BillingSettingsPage from "@/components/BillingSettingsPage";
import { ScrollText, Link2, Users, BookUser, HardHat, Layers, Mail, ShieldCheck, Receipt, Warehouse, Plug, Briefcase, Inbox, Stamp } from "lucide-react";
import OpsPermissionsPage from "@/components/OpsPermissionsPage";
import PurchasingSettingsPage from "@/components/PurchasingSettingsPage";
import IntegrationsSettingsPage from "@/components/IntegrationsSettingsPage";
import SalesSettingsPage from "@/components/SalesSettingsPage";
import InboxSettingsPage from "@/components/InboxSettingsPage";
import SubmittalSettingsPage from "@/components/SubmittalSettingsPage";
import AdminSettings from "@/budget/pages/admin/AdminSettings";
const SUBTABS = [
  { key: "users", label: "Users", icon: Users },
  { key: "sales", label: "Sales", icon: Briefcase },
  { key: "inbox", label: "Inbox", icon: Inbox },
  { key: "budgets", label: "Budgets" },
  { key: "directory", label: "Directory", icon: BookUser },
  { key: "field", label: "Field", icon: HardHat },
  { key: "field-codes", label: "Field Codes", icon: Layers },
  { key: "purchasing", label: "Purchasing", icon: Warehouse },
  { key: "submittals", label: "Submittals", icon: Stamp },
  { key: "integrations", label: "Integrations", icon: Plug },
  { key: "audit", label: "Audit Log", icon: ScrollText },
  { key: "cost-codes", label: "Cost Codes", icon: Link2 },
  { key: "email", label: "Email", icon: Mail },
  { key: "billing", label: "Billing", icon: Receipt },
  { key: "permissions", label: "Permissions", icon: ShieldCheck },
];

export default function SettingsShell() {
  const [raw, setSubTab] = useUrlState("sub", "users");
  const subTab = SUBTABS.some((t) => t.key === raw) ? raw : "users";

  return (
    <div className="flex-1 overflow-hidden flex flex-col" data-testid="settings-shell">
      <SubTabs
        tabs={SUBTABS.map(({ key, label, icon }) => ({ key, label, icon, testId: `settings-subtab-${key}` }))}
        active={subTab}
        onChange={setSubTab}
        testId="settings-subtabs"
      />

      {/* Sub-tab content */}
      <div className="flex-1 overflow-hidden flex flex-col">
        {subTab === "permissions" && (
          <div className="page-body"><OpsPermissionsPage /></div>
        )}
        {subTab === "purchasing" && (
          <div className="fo-scope flex-1 min-h-0 flex flex-col"><PurchasingSettingsPage /></div>
        )}
        {subTab === "submittals" && (
          <div className="flex-1 min-h-0 overflow-y-auto"><SubmittalSettingsPage /></div>
        )}
        {subTab === "integrations" && (
          <div className="fo-scope flex-1 min-h-0 flex flex-col"><IntegrationsSettingsPage /></div>
        )}
        {subTab === "sales" && <SalesSettingsPage />}
        {subTab === "inbox" && <InboxSettingsPage />}
        {subTab === "budgets" && <AdminSettings />}
        {subTab === "audit" && <AuditLogPage />}
        {subTab === "email" && <EmailTemplatesPage />}
        {subTab === "billing" && <BillingSettingsPage />}
        {subTab === "cost-codes" && <CostCodesPage />}
        {subTab === "users" && <UsersRolesPage />}
        {subTab === "directory" && <DirectoryPage />}
        {subTab === "field-codes" && (
          <div className="fo-scope flex-1 overflow-hidden flex flex-col"><FieldCodesPage /></div>
        )}
        {/* The field settings page keeps its own providers (role banner, back/forward). */}
        {subTab === "field" && (
          <RoleProvider>
            <NavHistoryProvider>
              <div className="fo-scope page-body" data-testid="settings-field-pane">
                <FieldSettingsPage />
              </div>
            </NavHistoryProvider>
          </RoleProvider>
        )}
      </div>
    </div>
  );
}
